/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Imagen from '../../Imagen/Imagen';
import Botonera from '../../Botonera/Botonera';
import useLoadImages from '../../../hooks/useLoadImages';
import { generaListadoImagenes as generaListadoHorario } from '../../../utils/generaListadoImagenes';

import moment from 'moment';
import Slider from '@mui/material/Slider';
import { Box, Button } from '@mui/material';

import CircularProgress from '@mui/material/CircularProgress';
import CustomSlider from '../../CustomSlider/CustomSlider';
import { imagenAnerior, imagenSiguiente, pause, reproducir, stop } from '../controls';
import Referencias from './Referencias/Referencias';
import Valores from './Valores';


//  "homepage": "https://www.inumet.gub.uy/reportes/pages/visualizadorFWI/"
const TITLE = "Visualizador FWI - INUMET"
const IMAGE_BASE_PATH = "https://www.inumet.gub.uy/reportes/fwi/"
const IMAGE_BASE_NAME_FORMAT = "YYYY_MM_DD"
const DATE_FORMAT_TO_DISPLAY = "DD/MM/YYYY"
const INTERVAL_IMAGES = [1, "days"]
const MAX_DATE_INTERVAL = [10, 'days']
const MIN_DATE = moment().subtract(10, "minutes")
const DESCRIPTION = ` <h2>Descripción: </h2>
<p>El FWI es un índice basado en observaciones meteorológicas desarrollado en Canadá en 1970 para estimar el peligro de incendios forestales. Actualmente es uno de los índices más utilizados en el mundo. Se compone por diferentes términos que tienen en cuenta los efectos de la humedad de los materiales combustibles y del viento en el comportamiento y la propagación del fuego.</p>
<p>
    Valores altos de FWI indican condiciones meteorológicas más favorables para desencadenar un incendio forestal. Al ser un índice adaptable a distintas condiciones climáticas, según la región de aplicación, requiere calibración de los distintos niveles de peligro de incendio.</p>
<p>A partir de los valores del FWI y de la calibración de los niveles de riesgo, se presentan mapas diarios de riesgo que caracterizan el peligro de incendios forestales en todo el territorio nacional.</p>`




const PlayerFwi = () => {
    const listadoHorario = useMemo(() => generaListadoHorario({ MIN_DATE, MAX_DATE_INTERVAL, IMAGE_BASE_NAME_FORMAT, INTERVAL_IMAGES }), [])
    const [listadoImagenes, setListadoImagenes] = useState([])
    const [fechaMuestra, setFechaMuestra] = useState(MIN_DATE.utc().format('DD/MM/YYYY HH:mm'))
    const [velocidad, setVelocidad] = useState(800)
    const [idReproduccion, setIdReproduccion] = useState(0)
    const [posicion, setPosicion] = useState(0);
    const [reproduciendo, setReproduciendo] = useState(0)



    const { images: imagenes_fwi, error: error_fwi, isLoading: isLoading_fwi, urls: urls_fwi } = useLoadImages(
        {
            prefijo: 'FWI_',
            sufijo: '',
            listadoImagenes: listadoHorario,
            posicion,
            extencion: 'png',
            IMAGE_BASE_PATH
        })



    const formatearFechaMuestra = useCallback(() => {
        if (listadoImagenes.length === 0) return
        const date = moment(listadoImagenes[posicion].dateTime, IMAGE_BASE_NAME_FORMAT)
        setFechaMuestra(date.format(DATE_FORMAT_TO_DISPLAY))

    }, [posicion, listadoImagenes])







    const generaListadoImagenes = useCallback(() => {
        const listadoImagenes = []
        listadoHorario.forEach((fecha) => {
            if (imagenes_fwi[fecha]) listadoImagenes.push({ fwi: imagenes_fwi[fecha], dateTime: fecha, urls_fwi: urls_fwi[fecha] })
        })
        setListadoImagenes(listadoImagenes)
    }, [imagenes_fwi, listadoHorario, urls_fwi])




    useEffect(() => {
        generaListadoImagenes()
    }, [imagenes_fwi, generaListadoImagenes])

    useEffect(() => {
        if (reproduciendo === 1) {
            setTimeout(() => {
                imagenSiguiente({ reproduciendo, listadoImagenes, posicion, setPosicion })
            }, velocidad)
        }
        formatearFechaMuestra()
    }, [reproduciendo, posicion, idReproduccion, velocidad, formatearFechaMuestra, listadoImagenes])

    useEffect(() => {
        document.title = TITLE
    }, [])


    if (isLoading_fwi || listadoImagenes.length < 1) return <Box
        sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            justifyItems: "center",
        }}
    >
        <CircularProgress color="primary" />

    </Box>

    return (
        <Box
            sx={{
                maxWidth: "100vw",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Botonera
                stop={() => stop({ idReproduccion, setReproduciendo, setPosicion, setIdReproduccion })}
                pause={() => pause({ idReproduccion, setReproduciendo })}
                aumentarVelocidad={() => setVelocidad(velocidad - 100)}
                disminuirVelocidad={() => setVelocidad(velocidad + 100)}
                reproducir={() => reproducir({ reproduciendo, setReproduciendo })}
                imagenSiguiente={() => imagenSiguiente({ reproduciendo, listadoImagenes, posicion, setPosicion })}
                imagenAnerior={() => imagenAnerior({ listadoImagenes, posicion, setPosicion })}
                reproduciendo={reproduciendo}
            />

            <CustomSlider reproduciendo={reproduciendo} listadoImagenes={listadoImagenes} posicion={posicion} setPosicion={setPosicion} fechaMuestra={fechaMuestra} />

            <Box
                sx={{
                    display: "flex",

                    flexWrap: "wrap",
                    maxWidth: "100vw",
                    maxHeight: "100vh",
                    justifyContent: "center",
                }}
            >
                <Imagen src={listadoImagenes[posicion].fwi} error={error_fwi} downloadLink={listadoImagenes[posicion].urls_fwi.replace('.png', '.tif')} />
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        width: '100vw',
                        lineHeight: '2rem',
                        fontSize: "1rem",

                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            width: '100vw',
                            lineHeight: '2rem',
                            flexWrap: 'wrap',
                        }}
                    >
                        <Referencias />
                        <Valores />
                    </Box>

                </Box>

                <Box

                    sx={{
                        fontSize: "1rem",
                        fontFamily: "Roboto",
                        textAlign: "left",
                        color: 'primary.dark',
                        p: 2,
                        m: 2,
                        maxWidth: { xs: "100vw", sm: "50vw" },

                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: DESCRIPTION }} />
                    <Button variant="text" target='_blank' href="/pdf/Riesgo_incendio_02.pdf">
                        Más información
                    </Button>
                </Box>

            </Box>
        </Box>
    );
}

export default PlayerFwi
